export default "__VITE_ASSET__K_xGKPqo__"